export default __webpack_public_path__ + "static/media/keller-before-after1-mobile.a998ee27.svg";